import { gql } from '@apollo/client';

export default gql`
  fragment RefundMethodsPayment on Payment {
    id
    refId
    reference
    currency
    externalReference
    method
    isPayout
    isBalance
    provider
    availableRefundAmount
    isSuccessful
    amount: amountWithCurrency(currency: $currency)
    amountInOriginalCurrency: amountWithCurrency
    availableRefundAmount
    refundProcessTimestamp
    transactionTimestamp
    paymentStatus
  }
`;
